import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-corporate-tabs',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './corporate-tabs.component.html',
  styleUrls: ['./corporate-tabs.component.scss'],
})
export class CorporateTabsComponent implements OnInit {
  @Input() accountId!: string;
  @Input() accountNumber!: string;

  tabs: { path: string; label: string; route: string }[] = [];

  router = inject(Router);

  private pathMap = new Map<string, string>([
    ['details', 'Details'],
    ['signatories', 'Signatories'],
    ['wallet', 'Wallet'],
    ['portfolio', 'Portfolio'],
    ['orders', 'Orders'],
    ['audit-log', 'Audit Log'],
    ['rm-list', 'Relationship Manager(s)'],
  ]);

  ngOnInit(): void {
    this.initializeTabs();
  }

  private initializeTabs(): void {
    this.tabs = Array.from(this.pathMap, ([path, label]) => ({
      path,
      label,
      route: this.getRoutePath(path),
    }));
  }

  getRoutePath(path: string): string {
    const currentPath = this.router.url;
    const arr = currentPath.split('/');

    // Special handling for 'portfolio'
    if (path === 'portfolio') {
      // Find index of first occurrence of 'portfolio'
      const portfolioIndex = arr.indexOf('portfolio');

      // Slice everything before the first 'portfolio'
      const baseRoute =
        portfolioIndex > -1
          ? arr.slice(0, portfolioIndex).join('/')
          : arr.slice(0, -1).join('/');

      return `${baseRoute}/portfolio/${this.accountNumber}/portfolio/`;
    }

    // Remove '/portfolio/:accountNumber/portfolio' if it exists
    const portfolioIndex = arr.indexOf('portfolio');
    if (
      portfolioIndex !== -1 &&
      arr.length > portfolioIndex + 2 &&
      arr[portfolioIndex + 2] === 'portfolio'
    ) {
      const baseRoute = arr.slice(0, portfolioIndex).join('/');
      return `${baseRoute}/${path}`;
    }
    // Default case: replace last segment with the new path
    return currentPath.replace(`${arr[arr.length - 1]}`, path);
  }
}
